import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes.ts'

import { FilterSelector } from 'pages/tours/filter-room-page/components'
import { hasActiveFilters } from 'pages/tours/filter-room-page/lib/hasActiveFilters'
import { EmptyFilters } from 'pages/tours/filter-room-page/types.ts'

import { usePreparedRoomFilters } from 'entities/tour/hooks/usePreparedRoomFilters.ts'
import { selectionStore } from 'entities/tour/models'
import { SelectedRoomFilters } from 'entities/tour/models/selection-store/selection-store.ts'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import s from './styles.module.scss'

const FilterRoomPage = observer(() => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const hotelDetail = selectionStore.getSelectedHotel()
  const storeFilters = selectionStore.getRoomFilters()

  const [localFilters, setLocalFilters] =
    useState<SelectedRoomFilters>(storeFilters)

  const { preparedMeal, preparedOperators, preparedRoomTypes } =
    usePreparedRoomFilters(hotelDetail?.tour_filter_data)

  const updateFilter =
    (filterName: keyof SelectedRoomFilters) => (values: string[]) => {
      setLocalFilters((prev) => ({
        ...prev,
        [filterName]: values,
      }))
    }

  const handleBack = () => {
    navigate(-1)
  }

  const handleResetFilters = () => {
    setLocalFilters(EmptyFilters)
  }

  const isFiltersActive = hasActiveFilters(localFilters)

  const handleApplyFilters = () => {
    selectionStore.setRoomFilters(localFilters)

    navigate(-1)
  }

  useEffect(() => {
    if (!hotelDetail) navigate(RoutingPaths.tours.start())
  }, [])

  return (
    <div className={s.container}>
      <HeaderResetButton
        title={t('filter')}
        isIconBlack
        onBack={handleBack}
        onReset={handleResetFilters}
        isCanDisable={isFiltersActive}
      />

      <div className={s.box}>
        <FilterSelector
          hasAll
          title="tours_block.type_meat"
          selected={localFilters.meal_type}
          options={preparedMeal}
          onChange={updateFilter('meal_type')}
        />

        <FilterSelector
          hasAll
          title="tours_block.room_type"
          selected={localFilters.room_types}
          options={preparedRoomTypes}
          onChange={updateFilter('room_types')}
        />

        <FilterSelector
          hasAll
          title="tours_block.operator_filter"
          selected={localFilters.operators}
          options={preparedOperators}
          onChange={updateFilter('operators')}
        />
      </div>

      <ButtonContinue
        onClick={handleApplyFilters}
        className={s.btn}
      >
        <span className="bold-16">{t('apply')}</span>
      </ButtonContinue>
    </div>
  )
})

export default FilterRoomPage
